/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _title__visibilite_digitale_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Visibilité digitale' }],
    'fr',
);

const _title__visibilite_digitale_en = new IntlMessageFormat(
    [{ type: 0, value: 'Digital visibility' }],
    'en',
);

export function title__visibilite_digitale(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__visibilite_digitale_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__visibilite_digitale_en.format(args) as unknown as string;
    }

    return _title__visibilite_digitale_fr.format(args) as unknown as string;
}

const _desc__visibilite_digitale_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Bénéficiez d’une présence efficace et d’une bonne image sur internet',
        },
    ],
    'fr',
);

const _desc__visibilite_digitale_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Benefit from an effective presence and a good image on the internet',
        },
    ],
    'en',
);

export function desc__visibilite_digitale(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__visibilite_digitale_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__visibilite_digitale_en.format(args) as unknown as string;
    }

    return _desc__visibilite_digitale_fr.format(args) as unknown as string;
}

const _title__devis_centralisee_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Devis centralisés' }],
    'fr',
);

const _title__devis_centralisee_en = new IntlMessageFormat(
    [{ type: 0, value: 'Centralized quotes' }],
    'en',
);

export function title__devis_centralisee(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__devis_centralisee_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__devis_centralisee_en.format(args) as unknown as string;
    }

    return _title__devis_centralisee_fr.format(args) as unknown as string;
}

const _desc__devis_centralisee_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Obtenez des demandes de devis de la part de prospects qualifiés',
        },
    ],
    'fr',
);

const _desc__devis_centralisee_en = new IntlMessageFormat(
    [{ type: 0, value: 'Get quote requests from qualified prospects' }],
    'en',
);

export function desc__devis_centralisee(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__devis_centralisee_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__devis_centralisee_en.format(args) as unknown as string;
    }

    return _desc__devis_centralisee_fr.format(args) as unknown as string;
}

const _title__inbox_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Messagerie instantanée' }],
    'fr',
);

const _title__inbox_en = new IntlMessageFormat(
    [{ type: 0, value: 'Instant messaging' }],
    'en',
);

export function title__inbox(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__inbox_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__inbox_en.format(args) as unknown as string;
    }

    return _title__inbox_fr.format(args) as unknown as string;
}

const _desc__inbox_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Discutez en direct avec vos prospects et contacts' }],
    'fr',
);

const _desc__inbox_en = new IntlMessageFormat(
    [{ type: 0, value: 'Chat live with your prospects and contacts' }],
    'en',
);

export function desc__inbox(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__inbox_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__inbox_en.format(args) as unknown as string;
    }

    return _desc__inbox_fr.format(args) as unknown as string;
}

const _title__avis_clients_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Avis clients' }],
    'fr',
);

const _title__avis_clients_en = new IntlMessageFormat(
    [{ type: 0, value: 'Customer reviews' }],
    'en',
);

export function title__avis_clients(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__avis_clients_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__avis_clients_en.format(args) as unknown as string;
    }

    return _title__avis_clients_fr.format(args) as unknown as string;
}

const _desc__avis_clients_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Renforcez la confiance de vos futurs clients' }],
    'fr',
);

const _desc__avis_clients_en = new IntlMessageFormat(
    [{ type: 0, value: 'Build trust with your future customers' }],
    'en',
);

export function desc__avis_clients(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__avis_clients_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__avis_clients_en.format(args) as unknown as string;
    }

    return _desc__avis_clients_fr.format(args) as unknown as string;
}

const _title__campagnes_emails_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Campagnes Emails et SMS' }],
    'fr',
);

const _title__campagnes_emails_en = new IntlMessageFormat(
    [{ type: 0, value: 'Email and SMS campaigns' }],
    'en',
);

export function title__campagnes_emails(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__campagnes_emails_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__campagnes_emails_en.format(args) as unknown as string;
    }

    return _title__campagnes_emails_fr.format(args) as unknown as string;
}

const _desc__campagnes_emails_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Touchez directement jusqu’à 600.000 contacts ciblés et qualifiés',
        },
    ],
    'fr',
);

const _desc__campagnes_emails_en = new IntlMessageFormat(
    [{ type: 0, value: 'Directly reach up to 600,000 targeted and qualified contacts' }],
    'en',
);

export function desc__campagnes_emails(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__campagnes_emails_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__campagnes_emails_en.format(args) as unknown as string;
    }

    return _desc__campagnes_emails_fr.format(args) as unknown as string;
}

const _title__afrikad_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Afrikad.com : notre plateforme de sites éditeurs' }],
    'fr',
);

const _title__afrikad_en = new IntlMessageFormat(
    [{ type: 0, value: 'Afrikad.com: our publisher sites platform' }],
    'en',
);

export function title__afrikad(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__afrikad_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__afrikad_en.format(args) as unknown as string;
    }

    return _title__afrikad_fr.format(args) as unknown as string;
}

const _mobile_title__afrikad_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Afrikad.com : régie publicitaire' }],
    'fr',
);

const _mobile_title__afrikad_en = new IntlMessageFormat(
    [{ type: 0, value: 'Afrikad.com: advertising network' }],
    'en',
);

export function mobile_title__afrikad(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _mobile_title__afrikad_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _mobile_title__afrikad_en.format(args) as unknown as string;
    }

    return _mobile_title__afrikad_fr.format(args) as unknown as string;
}

const _navbar_title__afrikad_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Régie publicitaire' }],
    'fr',
);

const _navbar_title__afrikad_en = new IntlMessageFormat(
    [{ type: 0, value: 'Advertising network' }],
    'en',
);

export function navbar_title__afrikad(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _navbar_title__afrikad_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _navbar_title__afrikad_en.format(args) as unknown as string;
    }

    return _navbar_title__afrikad_fr.format(args) as unknown as string;
}

const _desc__afrikad_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Afrikad vous offre l’audience de plus de 150 sites internet locaux au service de votre communication',
        },
    ],
    'fr',
);

const _desc__afrikad_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Afrikad offers you the audience of more than 150 local websites for your communication',
        },
    ],
    'en',
);

export function desc__afrikad(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__afrikad_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__afrikad_en.format(args) as unknown as string;
    }

    return _desc__afrikad_fr.format(args) as unknown as string;
}

const _title__shopping_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Présentez vos produits à vendre' }],
    'fr',
);

const _title__shopping_en = new IntlMessageFormat(
    [{ type: 0, value: 'Showcase your products for sale' }],
    'en',
);

export function title__shopping(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__shopping_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__shopping_en.format(args) as unknown as string;
    }

    return _title__shopping_fr.format(args) as unknown as string;
}

const _mobile_title__shopping_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vos produits à vendre' }],
    'fr',
);

const _mobile_title__shopping_en = new IntlMessageFormat(
    [{ type: 0, value: 'Your products for sale' }],
    'en',
);

export function mobile_title__shopping(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _mobile_title__shopping_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _mobile_title__shopping_en.format(args) as unknown as string;
    }

    return _mobile_title__shopping_fr.format(args) as unknown as string;
}

const _navbar_title__shopping_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vos produits à vendre' }],
    'fr',
);

export function navbar_title__shopping(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _navbar_title__shopping_fr.format(args) as unknown as string;
    }

    return _navbar_title__shopping_fr.format(args) as unknown as string;
}

const _desc__shopping_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Service dédié à la présentation de vos produits ou services : photos, descriptifs, prix…',
        },
    ],
    'fr',
);

const _desc__shopping_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Service dedicated to presenting your products or services: photos, descriptions, prices...',
        },
    ],
    'en',
);

export function desc__shopping(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__shopping_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__shopping_en.format(args) as unknown as string;
    }

    return _desc__shopping_fr.format(args) as unknown as string;
}

const _title__rdv_en_ligne_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Prise de rendez-vous en ligne' }],
    'fr',
);

const _title__rdv_en_ligne_en = new IntlMessageFormat(
    [{ type: 0, value: 'Online appointment booking' }],
    'en',
);

export function title__rdv_en_ligne(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__rdv_en_ligne_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__rdv_en_ligne_en.format(args) as unknown as string;
    }

    return _title__rdv_en_ligne_fr.format(args) as unknown as string;
}

const _navbar_title__rdv_en_ligne_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Rendez-vous en ligne' }],
    'fr',
);

const _navbar_title__rdv_en_ligne_en = new IntlMessageFormat(
    [{ type: 0, value: 'Online appointments' }],
    'en',
);

export function navbar_title__rdv_en_ligne(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _navbar_title__rdv_en_ligne_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _navbar_title__rdv_en_ligne_en.format(args) as unknown as string;
    }

    return _navbar_title__rdv_en_ligne_fr.format(args) as unknown as string;
}

const _desc__rdv_en_ligne_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Vos prospects peuvent vous demander un rendez-vous directement depuis Go Africa Online',
        },
    ],
    'fr',
);

const _desc__rdv_en_ligne_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Your prospects can request an appointment directly from Go Africa Online',
        },
    ],
    'en',
);

export function desc__rdv_en_ligne(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__rdv_en_ligne_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__rdv_en_ligne_en.format(args) as unknown as string;
    }

    return _desc__rdv_en_ligne_fr.format(args) as unknown as string;
}

const _title__charte_verification_entreprise_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Entreprises vérifiées' }],
    'fr',
);

const _title__charte_verification_entreprise_en = new IntlMessageFormat(
    [{ type: 0, value: 'Verified companies' }],
    'en',
);

export function title__charte_verification_entreprise(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__charte_verification_entreprise_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__charte_verification_entreprise_en.format(
            args,
        ) as unknown as string;
    }

    return _title__charte_verification_entreprise_fr.format(args) as unknown as string;
}

const _navigation_title__charte_verification_entreprise_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Charte de vérification' }],
    'fr',
);

const _navigation_title__charte_verification_entreprise_en = new IntlMessageFormat(
    [{ type: 0, value: 'Verification charter' }],
    'en',
);

export function navigation_title__charte_verification_entreprise(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _navigation_title__charte_verification_entreprise_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _navigation_title__charte_verification_entreprise_en.format(
            args,
        ) as unknown as string;
    }

    return _navigation_title__charte_verification_entreprise_fr.format(
        args,
    ) as unknown as string;
}

const _title__reseau_social_pro_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Réseau social professionnel' }],
    'fr',
);

const _title__reseau_social_pro_en = new IntlMessageFormat(
    [{ type: 0, value: 'Professional social network' }],
    'en',
);

export function title__reseau_social_pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__reseau_social_pro_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__reseau_social_pro_en.format(args) as unknown as string;
    }

    return _title__reseau_social_pro_fr.format(args) as unknown as string;
}

const _desc__reseau_social_pro_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Développez votre communauté d'abonnés et l'impact de vos publications",
        },
    ],
    'fr',
);

const _desc__reseau_social_pro_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Develop your subscriber community and the impact of your publications',
        },
    ],
    'en',
);

export function desc__reseau_social_pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _desc__reseau_social_pro_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _desc__reseau_social_pro_en.format(args) as unknown as string;
    }

    return _desc__reseau_social_pro_fr.format(args) as unknown as string;
}

const _title__articles_fr = new IntlMessageFormat([{ type: 0, value: 'Articles' }], 'fr');

const _title__articles_en = new IntlMessageFormat([{ type: 0, value: 'Articles' }], 'en');

export function title__articles(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _title__articles_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _title__articles_en.format(args) as unknown as string;
    }

    return _title__articles_fr.format(args) as unknown as string;
}

const _grid_title_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Découvrez tous les services de Go Africa Online et entrez dans un monde de contacts',
        },
    ],
    'fr',
);

const _grid_title_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Discover all Go Africa Online services and enter a world of contacts',
        },
    ],
    'en',
);

export function grid_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _grid_title_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _grid_title_en.format(args) as unknown as string;
    }

    return _grid_title_fr.format(args) as unknown as string;
}

const _navigation_title__services_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Services' }],
    'fr',
);

const _navigation_title__services_en = new IntlMessageFormat(
    [{ type: 0, value: 'Services' }],
    'en',
);

export function navigation_title__services(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _navigation_title__services_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _navigation_title__services_en.format(args) as unknown as string;
    }

    return _navigation_title__services_fr.format(args) as unknown as string;
}

const _navigation_title__contact_us_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Contactez-nous' }],
    'fr',
);

const _navigation_title__contact_us_en = new IntlMessageFormat(
    [{ type: 0, value: 'Contact us' }],
    'en',
);

export function navigation_title__contact_us(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _navigation_title__contact_us_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _navigation_title__contact_us_en.format(args) as unknown as string;
    }

    return _navigation_title__contact_us_fr.format(args) as unknown as string;
}
